export default {
  title: {
    en: 'Want to try something else?',
  },
  text: {
    en: 'Add one of our best sellers for your first shipment.',
  },
  try: {
    en: 'Let’s try this',
  },
  selected: {
    en: 'Selected',
  },
  back: {
    en: 'Go back',
  },
}
